import { getUrlQueryParam } from '@/utils/helper';
import { globalCommit,commitLocalAndToGlobalService } from '@/utils/vuex';
import Constants from '@/utils/constants';
import { resendVerficationEmail, resendSGMVerificationEmail } from '@/service/api';
import { FETCH_UPDATE, FETCH_FAILURE, RESEND_MAIL_SUCCESS} from '@/store/actions';

export const EmailValidationModule = {
  namespaced: true,
  state: {
    isResendEmailSuccess: false
  },

  actions: {
    async resendVerificationMail({ commit, rootGetters }) {
      const { PresId, Id } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
      const emailAddress = rootGetters['login/GET_USER_EMAIL_ADDRESS'];
      const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
      const showLink = uniqueId ? rootGetters['conferenceCall/GET_SHOW_ID'] : getUrlQueryParam();
      globalCommit('service', commit, FETCH_UPDATE);
      commit(RESEND_MAIL_SUCCESS, false);
      try {
        if (Id == '') {
          await resendSGMVerificationEmail(PresId, emailAddress, showLink);
        } else {
          await resendVerficationEmail(PresId, Id, emailAddress, showLink, rootGetters['conferenceCall/GET_IS_LISTEN_ONLY']);
        }
        commitLocalAndToGlobalService(commit, RESEND_MAIL_SUCCESS, true);
      } catch (err) {
        globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    }, 
  },

  mutations: {
    [RESEND_MAIL_SUCCESS]: (state, resendEmailSent) => {
      state.isResendEmailSuccess = resendEmailSent;
    }
  },

  getters: {
    GET_IS_VERIFICATION_EMAIL_SENT: state => state.isResendEmailSuccess
  }
}
